var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PublicMenuLayoutV2", {
    attrs: { showInstallAppButton: "" },
    scopedSlots: _vm._u([
      {
        key: "nav-btn-items",
        fn: function() {
          return [
            _c(
              "b-nav-item",
              {
                staticClass:
                  "my-auto d-none d-desktop-block d-xl-block ml-0 ml-xl-2"
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/inicio-sesion" } },
                  [
                    _c("ArrowButton", {
                      attrs: {
                        text: _vm.$t("login-wrd"),
                        action: function() {
                          _vm.$router.push("/inicio-sesion")
                        },
                        reverse: "",
                        backgroundColor: _vm.BLUE_COLOUR,
                        textColor: _vm.WHITE_COLOUR
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-177f3aac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-177f3aac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Opensalud360Layout.vue
// module id = 2072
// module chunks = 120